import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { Suspense, useEffect } from "react";
import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from "react-relay";

import { PackageDetail } from "../../PackageDetail";
import { PackageDetailSkeleton } from "../../PackageDetail/components/PackageDetailSkeleton";
import { currentPackageIdAtom } from "../atoms";
import { CurrentPackageDetailQuery } from "./__generated__/CurrentPackageDetailQuery.graphql";
import { PackageType } from "./__generated__/ModalLoaderQuery.graphql";

export const CurrentPackageDetail = ({ type }: { type: PackageType }) => {
  const packageId = useAtomValue(currentPackageIdAtom);

  const [queryRef, loadQuery] = useQueryLoader<CurrentPackageDetailQuery>(
    CurrentPackageDetailQueryString
  );

  useEffect(() => {
    if (packageId) {
      loadQuery(
        { packageId, packageType: type },
        { fetchPolicy: "store-and-network" }
      );
    }
  }, [loadQuery, packageId, type]);

  return (
    <Suspense fallback={<PackageDetailSkeleton />}>
      {queryRef ? (
        <CurrentPackageDetailInner queryRef={queryRef} type={type} />
      ) : null}
    </Suspense>
  );
};

type InnerProps = {
  type: PackageType;
  queryRef: PreloadedQuery<CurrentPackageDetailQuery>;
};

const CurrentPackageDetailInner = ({ type, queryRef }: InnerProps) => {
  const data = usePreloadedQuery(CurrentPackageDetailQueryString, queryRef);
  return <PackageDetail type={type} memberPackageRef={data.package} />;
};

const CurrentPackageDetailQueryString = graphql`
  query CurrentPackageDetailQuery($packageId: ID!, $packageType: PackageType!) {
    package: node(id: $packageId) {
      ...PackageDetail_memberPackage
    }
  }
`;
